require('./bootstrap');

import 'babel-polyfill';
import 'slick-carousel';
require('./snippets/flash_message');
require('pc-bootstrap4-datetimepicker');

window.Vue = require('vue');

//import lodash as an instance method for all components as '$_'
Object.defineProperty(Vue.prototype, '$_', {value: _});

// for open ckeditor img in modal
window.magnificPopup = require('magnific-popup');

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


if (document.getElementById('forPartnerPage')) {
    function toggleMobileClass() {
        if ($(window).width() < 992) {
            $('.awards-img').addClass('awards-img-mob');
        } else {
            $('.awards-img').removeClass('awards-img-mob'); // Убираем класс для десктопа
        }
    }

    toggleMobileClass(); // Запуск при загрузке
    $(window).on('resize', toggleMobileClass); // Запуск при изменении размера

    // Регистрируем плагин
    gsap.registerPlugin(ScrollTrigger);

    // Ждем загрузки DOM, чтобы элементы точно существовали
    document.addEventListener("DOMContentLoaded", () => {

        const bgElements = document.querySelectorAll(".bg-parallax");
        if (bgElements.length > 0) {
            bgElements.forEach(bg => {
                gsap.to(bg, {
                    y: -180, // Смещение вверх
                    ease: "none",
                    scrollTrigger: {
                        trigger: bg.closest('.main-screen') || bg.closest('.products-screen') || bg,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: 1 // Плавность
                    }
                });
            });
        }

        const imgElements = document.querySelectorAll(".why-item .image img");
        if (imgElements.length > 0) {
            imgElements.forEach(img => {
                gsap.to(img, {
                    y: 100, // Смещение вниз
                    ease: "none",
                    scrollTrigger: {
                        trigger: img,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: 1 // Плавность
                    }
                });
            });
        }

        const awardImg = document.querySelectorAll(".awards-img-mob");
        if (awardImg.length > 0) {
            awardImg.forEach(el => {
                gsap.to(el, {
                    x: -500, // Отрицательное значение = сдвиг влево. Меняйте число для силы эффекта
                    ease: "none",
                    scrollTrigger: {
                        trigger: el.closest('.awards') || el, // Анимация привязана к появлению блока .about
                        start: "bottom bottom", // Начинается, когда верх блока .about появляется внизу экрана
                        end: "bottom top",   // Заканчивается, когда низ блока уходит вверх
                        scrub: 1             // Плавная привязка к скроллу
                    }
                });
            });
        }

        const leftParallaxElements = document.querySelectorAll(".paralax-to-left");
        if (leftParallaxElements.length > 0) {
            leftParallaxElements.forEach(el => {
                gsap.to(el, {
                    x: -1100, // Отрицательное значение = сдвиг влево. Меняйте число для силы эффекта
                    ease: "none",
                    scrollTrigger: {
                        trigger: el.closest('.about') || el, // Анимация привязана к появлению блока .about
                        start: "top bottom", // Начинается, когда верх блока .about появляется внизу экрана
                        end: "bottom top",   // Заканчивается, когда низ блока уходит вверх
                        scrub: 1             // Плавная привязка к скроллу
                    }
                });
            });
        }

        const productScreens = gsap.utils.toArray(".products-screen");
        productScreens.forEach((screen) => {
            // Находим список внутри конкретного экрана
            const productsList = screen.querySelector(".products-list");

            if (!productsList) return;

            // Вычисляем, насколько далеко нужно сдвинуть список
            // (общая ширина списка минус ширина экрана браузера)
            const getScrollAmount = () => {
                return -(productsList.scrollWidth - window.innerWidth + 200);
            };

            gsap.to(productsList, {
                x: getScrollAmount, // Двигаем по оси X на вычисленное расстояние
                ease: "none",       // Линейная анимация (важно для скролла!)
                scrollTrigger: {
                    trigger: screen,      // Триггер - сам экран .products-screen
                    start: "top top",     // Начинаем, когда верх экрана касается верха окна браузера
                    end: () => "+=" + Math.abs(getScrollAmount()), // Длина скролла равна расстоянию сдвига
                    pin: true,            // "Прикрепляем" экран на месте во время горизонтального скролла
                    scrub: 1,             // Плавная привязка к колесику мыши (1 секунда задержки)
                    invalidateOnRefresh: true // Пересчитывать значения при изменении размера окна
                }
            });
        });

        const contactsBlock = document.querySelector(".contacts");
        if (contactsBlock) {
            gsap.to(contactsBlock, {
                y: -200, // Отрицательное значение = сдвиг вверх. Меняйте число для силы эффекта
                ease: "none",
                scrollTrigger: {
                    trigger: contactsBlock,
                    start: "top bottom", // Начинается, когда верх блока появляется внизу экрана
                    end: "bottom top",   // Заканчивается, когда низ блока уходит вверх за экран
                    scrub: 1             // Плавная привязка к скроллу (1 секунда задержки)
                }
            });
            console.log("✅ Анимация контактов применена");
        }
    });
}


